/** @format */

import template from './gb-presenter-error.html';
import './gb-presenter-error.scss';

export const GbPresenterErrorComponent = {
    template,
    controller: class GbPresenterErrorComponent {
        constructor() {
            'ngInject';
        }
    },
};
